import * as Phaser from 'phaser';

export const GAME_WIDTH = 360;
export const GAME_HEIGHT = 640;

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  backgroundColor: '#87CEEB',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [],
  render: {
    pixelArt: false,
    antialias: true,
    powerPreference: 'high-performance',
  },
  disableContextMenu: true,
  input: {
    activePointers: 2,
  },
};
